<template>
  <v-sheet flat :style="{display: 'flex', flexDirection: 'column', width: '100vw'}">
    <v-row>
      <v-col v-if="step == 0" style="height: 100vh;" cols="12" md="12" class="d-flex justify-center">
        <v-card :style="{display: 'flex', flexDirection: 'column', height: '100%', 'justify-content': 'center'}" flat width="600" style="align-self: center; padding: 10px; justify-content: center;">
          <div class="mb-4">
            <v-img class="mx-auto" height="150" width="150" src="@/assets/epesis.png"></v-img>
          </div>
          <v-card-title class="mb-2">
            Rekisteröidy ePesikseen!
          </v-card-title>
          <v-form
            :lazy-validation="true"
            ref="form"
            @submit="submit"
          >
            <v-row>
              <v-col
                cols="12"
              >
                <v-text-field
                  type="text"
                  v-model="form.full_name"
                  :label="$t('full_name')"
                  :rules="required"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-text-field
              autocomplete="username"
              type="email"
              v-model="form.email"
              :label="$t('email')"
              :rules="emailRules"
            >
            </v-text-field>
            <v-text-field
              autocomplete="new-password"
              :label="$t('password')"
              type="password"
              placeholder="********"
              v-model="form.password"
              :rules="passRules"
            ></v-text-field>
            <v-text-field
              :label="$t('password_again')"
              autocomplete="new-password"
              type="password"
              placeholder="**********"
              v-model="form.password_again"
              :rules="required"
            ></v-text-field>
            <v-checkbox
              :rules="required"
            >
              <template v-slot:label>
                <span class="mr-1">Olen lukenut ja hyväksyn </span><a @click.stop target="_blank" href="https://tiimio-assets.s3.eu-west-1.amazonaws.com/ePesis_kayttoehdot.pdf">käyttöehdot</a>
              </template>
            </v-checkbox>
            <v-card-actions style="justify-content: center;">
              <v-btn large rounded class="mt-5" :loading="loading" type="submit" color="primary">{{$t('signin')}}</v-btn>
            </v-card-actions>
            <div style="text-align: center;">
              <v-btn x-small text @click="$router.push({path: '/login', query: $route.query})">{{$t('loginflow.login_here')}}</v-btn>
            </div>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-sheet>
</template>

<script>
import { mapActions } from 'vuex'
// import Create from '../components/team/Create.vue'
/*
  Possible query params
  plan=plan short name
  lang=language "en" or "fi"
*/
export default {
  components: {
    // Create
  },
  created() {
    let lang = this.$route.query?.lang
    let prev_lang = window.localStorage.getItem('tiimi-lang')
    if(lang && (lang == 'en' || lang == 'fi') && lang != prev_lang ) {
      window.localStorage.setItem('tiimi-lang', lang)
      window.location.reload()
    }

    if(lang == 'en' || lang == 'fi') {
      this.form.language = lang
    }
  },
  data: () => ({
    step: 0,
    form: {
      email: '',
      password: '',
      password_again: '',
      language: 'fi',
      full_name: ''
    },
    agree_to_terms: false,
    agree_to_terms_error: false,
    languages: [
      { value: 'fi', text: 'FI' },
    ],
    loading: false,
    passRules: [
      v => !!v || 'Vaaditaan',
      v => (v && v.length >= 8) || 'Väh. 8 merkkiä',
    ],
    required: [
      v => !!v || 'Vaaditaan',
    ],
    emailRules: [
      v => !!v || 'Vaaditaan',
      v => /.+@.+\..+/.test(v) || 'Virheellinen sähköpostiosoite',
    ],
  }),
  methods: {
    ...mapActions({
      signin: 'auth/signin',
      showSnackbar: 'noti/showSnackbar',
      error: 'noti/error',
      success: 'noti/success',
    }),
    ...mapActions('user', [
      'initUser'
    ]),
    changeLanguage(e) {
      this.$i18n.locale = e
      window.localStorage.setItem('tiimi-lang', e)
    },
    submit(e) {
      e.preventDefault();

      this.loading = true
      this.form.language = this.form.language || 'en'
      let val = this.$refs.form.validate()

      if(!val) {
        if(!this.agree_to_terms) this.agree_to_terms_error = true
        this.loading = false
        return
      }

      this.signin(this.form)
        .then(res => {
          console.log(res)
          this.initUser(res.data.token)

          this.$nextTick(() => {
            this.$router.push('/')
          })
          // this.showSnackbar({ text: this.$t('loginflow.signin_successfull'), duration: 12 })
          this.success('Tervetuloa ePesikseen!')
          this.track('Signed in')
        })
        .catch(err => {
          this.error(err)
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
  computed: {
    inbound() {
      return !!this.$route.query?.plan
    },
    stepperStep() {
      return 1
    }
  }
}
</script>